import RetailLayout from '../layouts/retail/Layout';
import PublicLayout from '../layouts/public/Layout';

import DashboardPage from '../pages/retail/dashboard/DashboardPage';
import LoginPage from '../pages/retail/access/LoginPage';
import ProfilePage from '../pages/retail/account/ProfilePage';
import PasswordPage from '../pages/retail/account/PasswordPage';

import ProductsPage from '../pages/retail/products/ProductsPage';
import ProductViewPage from '../pages/retail/products/ProductViewPage';

import MembersPage from '../pages/retail/users/members/MembersPage';
import MemberNewPage from '../pages/retail/users/members/MemberNewPage';
import MemberUpdatePage from '../pages/retail/users/members/MemberUpdatePage';

import SuppliersPage from '../pages/retail/users/supplier/SuppliersPage';
import SupplierNewPage from '../pages/retail/users/supplier/SupplierNewPage';
import SupplierUpdatePage from '../pages/retail/users/supplier/SupplierUpdatePage';
import SupplierViewPage from '../pages/retail/users/supplier/SupplierViewPage';

import ItemTransfersPage from '../pages/retail/documents/item_transfers/ItemTransfersPage';
import ItemTransferNewPage from '../pages/retail/documents/item_transfers/ItemTransferNewPage';
import ItemTransferUpdatePage from '../pages/retail/documents/item_transfers/ItemTransferUpdatePage';
import ItemTransferViewPage from '../pages/retail/documents/item_transfers/ItemTransferViewPage';
import ItemTransferVerifyTransferInPage from '../pages/retail/documents/item_transfers/ItemTransferVerifyTransferInPage';
import ItemTransferVerifyOutPage from '../pages/retail/documents/item_transfers/ItemTransferVerifyOutPage';

import ItemReceivesPage from '../pages/retail/documents/item_receives/ItemReceivesPage';
import ItemReceiveNewPage from '../pages/retail/documents/item_receives/ItemReceiveNewPage';
import ItemReceiveViewPage from '../pages/retail/documents/item_receives/ItemReceiveViewPage';
import ItemReceiveUpdatePage from '../pages/retail/documents/item_receives/ItemReceiveUpdatePage';
import ItemReceiveVerifyInPage from '../pages/retail/documents/item_receives/ItemReceiveVerifyInPage';

import ItemTransformPage from '../pages/retail/documents/item_transform/ItemTransformPage';
import ItemTransformNewPage from '../pages/retail/documents/item_transform/ItemTransformNewPage';
import ItemTransformViewPage from '../pages/retail/documents/item_transform/ItemTransformViewPage';

import ItemRelocatesPage from '../pages/retail/documents/item_relocates/ItemRelocatesPage';
import ItemRelocateNewPage from '../pages/retail/documents/item_relocates/ItemRelocateNewPage';
import ItemRelocateViewPage from '../pages/retail/documents/item_relocates/ItemRelocateViewPage';
// import ItemRelocateThresholdPage from '../pages/retail/documents/item_relocates/ItemRelocateThresholdPage';

import RetailCashSalesNewPage from '../pages/retail/documents/retail_cash_sales/RetailCashSalesNewPage';
import RetailCashSalesPage from '../pages/retail/documents/retail_cash_sales/RetailCashSalesPage';
import RetailCashSalesStockPostPage from '../pages/retail/documents/retail_cash_sales/RetailCashSalesStockPostPage';
import RetailCashSalesViewPage from '../pages/retail/documents/retail_cash_sales/RetailCashSalesViewPage';

import RetailPrescriptionNewPage from '../pages/retail/documents/retail_prescriptions/RetailPrescriptionNewPage';
import RetailPrescriptionsPage from '../pages/retail/documents/retail_prescriptions/RetailPrescriptionsPage';
import RetailPrescriptionViewPage from '../pages/retail/documents/retail_prescriptions/RetailPrescriptionViewPage';
import RetailPrescriptionUpdatePage from '../pages/retail/documents/retail_prescriptions/RetailPrescriptionUpdatePage';

import SalesOrderNewPage from '../pages/retail/documents/sales_orders/SalesOrderNewPage';
import SalesOrdersPage from '../pages/retail/documents/sales_orders/SalesOrdersPage';
import SalesOrderViewPage from '../pages/retail/documents/sales_orders/SalesOrderViewPage';
import SalesOrderUpdatePage from '../pages/retail/documents/sales_orders/SalesOrderUpdatePage';

import PurchaseOrdersPage from '../pages/retail/documents/purchase_orders/PurchaseOrdersPage';
import PurchaseOrderNewPage from '../pages/retail/documents/purchase_orders/PurchaseOrderNewPage';
import PurchaseOrderViewPage from '../pages/retail/documents/purchase_orders/PurchaseOrderViewPage';
import PurchaseOrderUpdatePage from '../pages/retail/documents/purchase_orders/PurchaseOrderUpdatePage';

import PurchaseReturnsPage from '../pages/retail/documents/purchase_return/PurchaseReturnsPage';
import PurchaseReturnNewPage from '../pages/retail/documents/purchase_return/PurchaseReturnNewPage';
import PurchaseReturnUpdatePage from '../pages/retail/documents/purchase_return/PurchaseReturnUpdatePage';
import PurchaseReturnVerifyOutPage from '../pages/retail/documents/purchase_return/PurchaseReturnVerifyOutPage';
import PurchaseReturnViewPage from '../pages/retail/documents/purchase_return/PurchaseReturnViewPage';

import PurchaseInvoicesPage from '../pages/retail/documents/purchase_invoice/PurchaseInvoicesPage';
import PurchaseInvoiceNewPage from '../pages/retail/documents/purchase_invoice/PurchaseInvoiceNewPage';
import PurchaseInvoiceUpdatePage from '../pages/retail/documents/purchase_invoice/PurchaseInvoiceUpdatePage';
import PurchaseInvoiceViewPage from '../pages/retail/documents/purchase_invoice/PurchaseInvoiceViewPage';

// import ItemAdjustmentsPage from '../pages/retail/documents/item_adjustments/ItemAdjustmentsPage';

import ViewInventoryPage from '../pages/retail/operations/inventory/ViewInventoryPage';

import StockTakesPage from '../pages/retail/documents/stock_takes/StockTakesPage';
import StockTakeNewPage from '../pages/retail/documents/stock_takes/StockTakeNewPage';
import StockTakeUpdatePage from '../pages/retail/documents/stock_takes/StockTakeUpdatePage';
import StockTakeViewPage from '../pages/retail/documents/stock_takes/StockTakeViewPage';
import StockTakeExecutePage from '../pages/retail/documents/stock_takes/StockTakeExecutePage';

import TransferReturnsPage from '../pages/retail/documents/transfer_returns/TransferReturnsPage';
import TransferReturnNewPage from '../pages/retail/documents/transfer_returns/TransferReturnNewPage';
import TransferReturnUpdatePage from '../pages/retail/documents/transfer_returns/TransferReturnUpdatePage';
import TransferReturnViewPage from '../pages/retail/documents/transfer_returns/TransferReturnViewPage';
import TransferReturnVerifyTransferInPage from '../pages/retail/documents/transfer_returns/TransferReturnVerifyTransferInPage';
import TransferReturnVerifyOutPage from '../pages/retail/documents/transfer_returns/TransferReturnVerifyOutPage';

import TransferRequisitionsPage from '../pages/retail/documents/transfer_requisitions/TransferRequisitionsPage';
import TransferRequisitionNewPage from '../pages/retail/documents/transfer_requisitions/TransferRequisitionNewPage';
import TransferRequisitionUpdatePage from '../pages/retail/documents/transfer_requisitions/TransferRequisitionUpdatePage';
import TransferRequisitionViewPage from '../pages/retail/documents/transfer_requisitions/TransferRequisitionViewPage';

import ItemReceiveReport from '../pages/retail/reports/warehouse/ItemReceiveReport';
import ItemReceiveItemReport from '../pages/retail/reports/warehouse/ItemReceiveItemReport';
import ItemTransferReport from '../pages/retail/reports/warehouse/ItemTransferReport';
import ItemTransferItemReport from '../pages/retail/reports/warehouse/ItemTransferItemReport';

// import SalesReport from '../pages/retail/reports/SalesReport';
// import RetailCashSalesReport from '../pages/retail/reports/RetailCashSalesReport';
// import DeliveryReport from '../pages/retail/reports/DeliveryReport';
// import RetailPrescriptionReport from '../pages/retail/reports/RetailPrescriptionReport';
// import ItemReceiveReport from '../pages/retail/reports/ItemReceiveReport';

export default function routes() {
    return [
        {
            path: '/retail',
            element: <PublicLayout/>,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: 'login', element: <LoginPage/> },
            ],
        },
        {
            path: '/retail',
            element: <RetailLayout/>,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: '', element: <DashboardPage/> },

                { path: 'dashboard', element: <DashboardPage/> },
                { path: 'profile', element: <ProfilePage/> },
                { path: 'password', element: <PasswordPage/> },

                { path: 'products', element: <ProductsPage/> },
                { path: 'product/item/view/:id', element: <ProductViewPage/> },

                { path: 'users/members', element: <MembersPage/> },
                { path: 'users/member/new', element: <MemberNewPage/> },
                { path: 'users/member/update/:id', element: <MemberUpdatePage/> },

                { path: 'users/suppliers', element: <SuppliersPage/> },
                { path: 'users/supplier/new', element: <SupplierNewPage/> },
                { path: 'users/supplier/update/:id', element: <SupplierUpdatePage/> },
                { path: 'users/supplier/view/:id', element: <SupplierViewPage/> },

                { path: 'documents/itemTransfers', element: <ItemTransfersPage/> },
                { path: 'documents/itemTransfer/new', element: <ItemTransferNewPage/> },
                { path: 'documents/itemTransfer/update/:id', element: <ItemTransferUpdatePage/> },
                { path: 'documents/itemTransfer/view/:id', element: <ItemTransferViewPage/> },
                { path: 'documents/itemTransfer/verifyTransferIn/:id', element: <ItemTransferVerifyTransferInPage/> },
                { path: 'documents/itemTransfer/verifyOut/:id', element: <ItemTransferVerifyOutPage/> },

                { path: 'documents/itemReceives', element: <ItemReceivesPage/> },
                { path: 'documents/itemReceive/new', element: <ItemReceiveNewPage/> },
                { path: 'documents/itemReceive/view/:id', element: <ItemReceiveViewPage/> },
                { path: 'documents/itemReceive/update/:id', element: <ItemReceiveUpdatePage/> },
                { path: 'documents/itemReceive/verifyIn/:id', element: <ItemReceiveVerifyInPage/> },

                { path: 'documents/itemTransform', element: <ItemTransformPage/> },
                { path: 'documents/itemTransform/new', element: <ItemTransformNewPage/> },
                { path: 'documents/itemTransform/view/:id', element: <ItemTransformViewPage/> },

                { path: 'documents/itemRelocates', element: <ItemRelocatesPage/> },
                { path: 'documents/itemRelocate/new', element: <ItemRelocateNewPage/> },
                { path: 'documents/itemRelocate/view/:id', element: <ItemRelocateViewPage/> },
                // { path: 'documents/itemRelocate/threshold', element: <ItemRelocateThresholdPage /> },

                { path: 'documents/retailCashSales', element: <RetailCashSalesPage/> },
                { path: 'documents/retailCashSales/new', element: <RetailCashSalesNewPage/> },
                { path: 'documents/retailCashSales/stockPost/:id', element: <RetailCashSalesStockPostPage/> },
                { path: 'documents/retailCashSales/view/:id', element: <RetailCashSalesViewPage/> },

                { path: 'documents/retailPrescriptions', element: <RetailPrescriptionsPage/> },
                { path: 'documents/retailPrescription/new', element: <RetailPrescriptionNewPage/> },
                { path: 'documents/retailPrescription/view/:id', element: <RetailPrescriptionViewPage/> },
                { path: 'documents/retailPrescription/update/:id', element: <RetailPrescriptionUpdatePage/> },

                { path: 'documents/salesOrders', element: <SalesOrdersPage/> },
                { path: 'documents/salesOrder/new', element: <SalesOrderNewPage/> },
                { path: 'documents/salesOrder/view/:id', element: <SalesOrderViewPage/> },
                { path: 'documents/salesOrder/update/:id', element: <SalesOrderUpdatePage/> },

                { path: 'documents/purchaseOrders', element: <PurchaseOrdersPage/> },
                { path: 'documents/purchaseOrder/new', element: <PurchaseOrderNewPage/> },
                { path: 'documents/purchaseOrder/view/:id', element: <PurchaseOrderViewPage/> },
                { path: 'documents/purchaseOrder/update/:id', element: <PurchaseOrderUpdatePage/> },

                { path: 'documents/purchaseReturns', element: <PurchaseReturnsPage/> },
                { path: 'documents/purchaseReturn/new', element: <PurchaseReturnNewPage/> },
                { path: 'documents/purchaseReturn/update/:id', element: <PurchaseReturnUpdatePage/> },
                { path: 'documents/purchaseReturn/view/:id', element: <PurchaseReturnViewPage/> },
                { path: 'documents/purchaseReturn/verifyOut/:id', element: <PurchaseReturnVerifyOutPage/> },

                { path: 'documents/purchaseInvoices', element: <PurchaseInvoicesPage/> },
                { path: 'documents/purchaseInvoice/new', element: <PurchaseInvoiceNewPage/> },
                { path: 'documents/purchaseInvoice/update/:id', element: <PurchaseInvoiceUpdatePage/> },
                { path: 'documents/purchaseInvoice/view/:id', element: <PurchaseInvoiceViewPage/> },

                // { path: 'documents/itemAdjustments', element: <ItemAdjustmentsPage /> },

                { path: 'documents/transferRequisitions', element: <TransferRequisitionsPage/> },
                { path: 'documents/transferRequisition/new', element: <TransferRequisitionNewPage/> },
                { path: 'documents/transferRequisition/update/:id', element: <TransferRequisitionUpdatePage/> },
                { path: 'documents/transferRequisition/view/:id', element: <TransferRequisitionViewPage/> },

                { path: 'documents/stockTakes', element: <StockTakesPage/> },
                { path: 'documents/stockTake/new', element: <StockTakeNewPage/> },
                { path: 'documents/stockTake/update/:id', element: <StockTakeUpdatePage/> },
                { path: 'documents/stockTake/view/:id', element: <StockTakeViewPage/> },
                { path: 'documents/stockTake/execute/:id', element: <StockTakeExecutePage/> },

                { path: 'documents/transferReturns', element: <TransferReturnsPage/> },
                { path: 'documents/transferReturn/new', element: <TransferReturnNewPage/> },
                { path: 'documents/transferReturn/update/:id', element: <TransferReturnUpdatePage/> },
                { path: 'documents/transferReturn/view/:id', element: <TransferReturnViewPage/> },
                { path: 'documents/transferReturn/verifyTransferIn/:id', element: <TransferReturnVerifyTransferInPage/> },
                { path: 'documents/transferReturn/verifyOut/:id', element: <TransferReturnVerifyOutPage/> },

                { path: 'operations/inventory/examine', element: <ViewInventoryPage/> },

                { path: 'reports/warehouse/itemReceive', element: <ItemReceiveReport/> },
                { path: 'reports/warehouse/itemReceiveItem', element: <ItemReceiveItemReport/> },
                { path: 'reports/warehouse/itemTransfer', element: <ItemTransferReport/> },
                { path: 'reports/warehouse/itemTransferItem', element: <ItemTransferItemReport/> },

                // { path: 'reports/sales', element: <SalesReport /> },
                // { path: 'reports/retailCashSales', element: <RetailCashSalesReport /> },
                // { path: 'reports/delivery', element: <DeliveryReport /> },
                // { path: 'reports/retailPrescription', element: <RetailPrescriptionReport /> },
                // { path: 'reports/itemReceive', element: <ItemReceiveReport /> },
            ],
        },
    ];
}
